jQuery(document).ready(function ($) {
    function setClassForSelect($select) {
        if(['', 'No min', 'No max', 'Pas de min', 'Pas de max'].includes($select.val())) {
            $select.addClass('defaultState');
        } else {
            $select.removeClass('defaultState');
        }
    }
   $('select').each(function () {
       setClassForSelect($(this));

       $(this).on('change', function() {
           setClassForSelect($(this));
       });
   });
});
